// Product Header — initialises linked main + thumbnail Swiper instances.
// Uses the globally-loaded Swiper v11 bundle (swiper-bundle.min.js).
// Scoped per section so multiple instances on one page work independently.

(function () {
  function initProductHeaders() {
    document.querySelectorAll('.product-header__inner').forEach(function (container) {
      var mainEl  = container.querySelector('.product-header__main-swiper');
      var thumbEl = container.querySelector('.product-header__thumb-swiper');

      if (!mainEl || typeof Swiper === 'undefined') return;
      if (mainEl.swiper) return; // already initialised (e.g. theme-editor re-render)

      var thumbSlider = container.querySelector('.product-header__thumb-slider');
      var desktop = window.matchMedia('(min-width: 990px)');
      var thumbsRight = !!container.closest('.product-header--thumbs-right');
      var thumbsSwiper = null;
      var mainSwiper = null;
      var startIndex = 0;

      function build() {
        if (thumbEl) {
          thumbsSwiper = new Swiper(thumbEl, {
            direction: thumbsRight && desktop.matches ? 'vertical' : 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 8,
            watchSlidesProgress: true,
            navigation: {
              nextEl: thumbSlider ? thumbSlider.querySelector('.swiper-button-next') : null,
              prevEl: thumbSlider ? thumbSlider.querySelector('.swiper-button-prev') : null,
            },
          });
        }

        mainSwiper = new Swiper(mainEl, {
          slidesPerView: 1,
          loop: false,
          initialSlide: startIndex,
          thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : false,
        });
      }

      build();

      if (thumbEl && thumbsRight) {
        desktop.addEventListener('change', function () {
          startIndex = mainSwiper.activeIndex;
          mainSwiper.destroy(true, true);
          thumbsSwiper.destroy(true, true);
          build();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductHeaders);
  } else {
    initProductHeaders();
  }

  // Tell Stamped's SDK to scan and populate any review badges in this section.
  // Stamped only auto-initialises on product/collection pages; on other page
  // types (or after a section is injected) loadBadges() must be called manually.
  // window.loadStampedBadges (assets/stamped.js) waits for Stamped to be ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.loadStampedBadges?.();
    });
  } else {
    window.loadStampedBadges?.();
  }
})();
